var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"groups"},[_vm._l((_vm.groups),function(group){return _c('com-group',{key:group.id,attrs:{"category":_vm.category,"group":group}})}),(!_vm.showItems && _vm.groups.length && _vm.showViewAll)?_c('router-link',{staticClass:"groups-all",attrs:{"to":_vm.linkAll}},[_vm._v("View All")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }